import { Badge } from '@/shared/ui';

type CollectionStatusProps = {
  /** undefined while loading, true if not yet applied, false if already applied. */
  available: boolean | undefined;
};

export const CollectionStatus = ({ available }: CollectionStatusProps) => {
  if (available === undefined) return <Badge variant="pending">Loading</Badge>;
  return available ? (
    <Badge variant="active">Available</Badge>
  ) : (
    <Badge variant="inactive">Already added</Badge>
  );
};
